import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useAuth } from '../hooks/useAuth';
import { Spinner } from '../components/common/UI';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await login(data);
      toast.success("Xush kelibsiz!");
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.detail || "Login yoki parol noto'g'ri.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, var(--sky-900) 0%, var(--sky-700) 50%, var(--sky-500) 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16, position: 'relative', overflow: 'hidden',
    }}>
      {/* Background decoration */}
      <div style={{
        position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none',
      }}>
        {[...Array(6)].map((_, i) => (
          <div key={i} style={{
            position: 'absolute',
            width: `${180 + i * 60}px`, height: `${180 + i * 60}px`,
            border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: '50%',
            top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
          }} />
        ))}
        <div style={{
          position: 'absolute', top: '10%', right: '15%',
          width: 300, height: 300,
          background: 'radial-gradient(circle, rgba(56,189,248,0.15) 0%, transparent 70%)',
        }} />
        <div style={{
          position: 'absolute', bottom: '15%', left: '10%',
          width: 250, height: 250,
          background: 'radial-gradient(circle, rgba(14,165,233,0.12) 0%, transparent 70%)',
        }} />
      </div>

      {/* Card */}
      <div className="scale-in" style={{
        background: 'rgba(255,255,255,0.97)',
        backdropFilter: 'blur(20px)',
        borderRadius: 'var(--radius-xl)',
        padding: '44px 40px',
        width: '100%', maxWidth: 420,
        boxShadow: '0 25px 60px rgba(7,89,133,0.35), 0 0 0 1px rgba(255,255,255,0.3)',
        position: 'relative',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            width: 64, height: 64,
            background: 'linear-gradient(135deg, var(--sky-500), var(--sky-700))',
            borderRadius: 18, margin: '0 auto 16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 28, boxShadow: '0 8px 24px rgba(14,165,233,0.35)',
          }}>💼</div>
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 28, fontWeight: 800,
            color: 'var(--sky-900)',
            letterSpacing: '-0.02em',
          }}>
            Oylik Bot
          </h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14, marginTop: 4 }}>
            Admin panelga kirish
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: 'block', marginBottom: 6,
              fontSize: 12, fontWeight: 700, letterSpacing: '0.06em',
              color: 'var(--text-secondary)', textTransform: 'uppercase',
            }}>
              Foydalanuvchi nomi
            </label>
            <input
              {...register('username', { required: 'Majburiy maydon' })}
              placeholder="admin"
              className="form-input"
              style={{
                border: errors.username ? '1.5px solid var(--rose-500)' : undefined
              }}
              autoFocus
            />
            {errors.username && (
              <p style={{ color: 'var(--rose-500)', fontSize: 12, marginTop: 4 }}>
                ⚠ {errors.username.message}
              </p>
            )}
          </div>

          <div style={{ marginBottom: 28 }}>
            <label style={{
              display: 'block', marginBottom: 6,
              fontSize: 12, fontWeight: 700, letterSpacing: '0.06em',
              color: 'var(--text-secondary)', textTransform: 'uppercase',
            }}>
              Parol
            </label>
            <input
              {...register('password', { required: 'Majburiy maydon' })}
              type="password"
              placeholder="••••••••"
              className="form-input"
              style={{
                border: errors.password ? '1.5px solid var(--rose-500)' : undefined
              }}
            />
            {errors.password && (
              <p style={{ color: 'var(--rose-500)', fontSize: 12, marginTop: 4 }}>
                ⚠ {errors.password.message}
              </p>
            )}
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={loading}
            style={{ width: '100%' }}
          >
            {loading ? <Spinner size="sm" color="current" /> : '🔐'}
            {loading ? 'Kirmoqda...' : 'Kirish'}
          </button>
        </form>

        <p style={{
          textAlign: 'center', marginTop: 24,
          fontSize: 12, color: 'var(--text-muted)',
        }}>
          Faqat administratorlar kirishi mumkin
        </p>
      </div>
    </div>
  );
}
